import { createFileRoute } from '@tanstack/react-router';
import { DestinationPolicyPage } from '../../features/settings/components/destination-policy-page.js';

export const Route = createFileRoute('/admin/destination-policy')({
  component: DestinationPolicyPage,
});
